import { AbstractControl, ValidatorFn } from '@angular/forms';

export function fileNameLengthValidator(maxLength: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const file = control.value;

    if (file && file.name.length > maxLength) {
      return { 'fileNameExceedsLimit': true };
    }

    return null;
  };
}
